import React from 'react'
import Link from 'redux-first-router-link'
import { FormattedMessage } from 'react-intl'
import ScaledImage from 'components/ScaledImage'
import styles from './GroupSummary.css'

const COVER_WIDTH = 120
const COVER_HEIGHT = 90

const LinkifiedGroup = ({ className, group, children }) => {
  return (
    <Link
      to={{
        type: group && group.closed
          ? group.outcome ? 'groups/group/outcome' : 'groups/group/posts'
          : 'groups/group/posts',
        payload: {
          group: group && group._id
        },
        meta: {
          push: true
        }
      }}
      className={className}
    >
      {children}
    </Link>
  )
}

const UnlinkifiedGroup = ({ className, children }) => (
  <div className={className}>{children}</div>
)

const GroupSummary = ({ group = {}, linkify = true, className }) => {
  let Wrapper = linkify ? LinkifiedGroup : UnlinkifiedGroup
  let cn = [styles.group_summary, className].join(' ')
  return (
    <Wrapper group={group} className={cn}>
      {group && group.image ? (
        <ScaledImage
          uuid={group.image.uuid}
          w={COVER_WIDTH}
          // h={3 * COVER_WIDTH / 5}
          h={COVER_HEIGHT}
          crop={false}
        />
      ) : null}
      <div className={styles.summary}>
        <h3>{group && group.name}</h3>
        <ul className={styles.meta}>
          <li>
            <FormattedMessage id={`group.summary.privacy.${group && group.privacy}`} />
            {group && group.closed ? (
              <span className={styles.closed}>
                <FormattedMessage id={`group.info.closed`} />
              </span>
            ) : null}
          </li>
          <li>
            <FormattedMessage id="group.summary.stats" values={group && group.stats} />
          </li>
        </ul>
      </div>
    </Wrapper>
  )
}

export default GroupSummary
